/**
 * ENUM
 * @todo: Add descricao
 */
export enum MarketingSenderStatusEnum {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    PENDING_VALIDATION = 'PENDING_VALIDATION'
}
